var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/**
 * @module:  内部调用
 * @author: Liang Huang
 * @date: 2019-09-17 18:13:18
 */


import generateJSBridgeTrigger from '../inner/triggerjsbridge';
export default function callinnerMixin(hybrid) {
  var os = hybrid.os,
      JSBridge = hybrid.JSBridge;
  var callJsBridge = generateJSBridgeTrigger(JSBridge);
  /**
   * 专门供API内部调用的，this指针被指向了proxy对象，方便处理
   * @param {Object} options 配置参数
   * @param {Function} resolve promise的成功回调
   * @param {Function} reject promise的失败回调
   */

  function callInner(options, resolve, reject) {
    var data = __assign({}, options); // 纯数据不需要回调


    delete data.success;
    delete data.error;
    delete data.dataFilter;
    var success = options.success,
        error = options.error,
        dataFilter = options.dataFilter;

    if (os.ywk) {
      // 默认ywk环境才触发jsbridge
      callJsBridge({
        handlerName: this.api.namespace,
        data: data,
        moduleName: this.api.moduleName,
        success: success,
        error: error,
        dataFilter: dataFilter,
        isLongCb: this.api.isLongCb,
        isEvent: this.api.isEvent
      }, resolve, reject);
    }
  }

  hybrid.callInner = callInner;
}